
// src/reducers/diary-form-reducer.js

import { 
  INSERT_DIARY_FORM,
  CLEAR_INSERT_DIARY_FORM,
} from '../actions/diary-form'

const initialState = {
  insert: {
    html: undefined,
  },
}

export default function diaryFormReducer(state = initialState, action = {}) {
  switch(action.type) {
  case INSERT_DIARY_FORM:
    return Object.assign({}, state, {
      insert: {
        html: action.html,
      }
    })

  case CLEAR_INSERT_DIARY_FORM:
    return Object.assign({}, state, {
      insert: {
        html: undefined,
      }
    })
 
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/diary-form-reducer.js